var _defs, _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _path4, _path5, _line, _circle5, _path6, _path7, _path8, _path9, _line2, _line3, _path10, _line4, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bc190;}.cls-2{fill:#356cb6;opacity:0.3;}.cls-3{fill:#393c54;}.cls-4{fill:#f85565;}.cls-5{fill:#fbc0aa;}.cls-6{fill:#f8dc25;}.cls-7{fill:#f2bc0f;}.cls-8{fill:#ffffff;}.cls-11,.cls-13,.cls-14,.cls-15,.cls-9{fill:none;stroke-linecap:round;}.cls-14,.cls-9{stroke:#fbc0aa;}.cls-13,.cls-14,.cls-15,.cls-9{stroke-linejoin:round;}.cls-9{stroke-width:12px;}.cls-10{fill:#ffd8c9;}.cls-11{stroke:#ffffff;stroke-miterlimit:10;stroke-width:3.68px;opacity:0.1;}.cls-12{fill:#515570;}.cls-13,.cls-15{stroke:#515570;stroke-width:2px;}.cls-14{stroke-width:4.71px;}.cls-15{opacity:0.2;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99,82a4,4,0,0,1-4-4V34h0a13,13,0,0,0-25.9,0h0l6,48a12,12,0,0,0,24,0Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 75,
    cy: 36,
    r: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,28h0A29.41,29.41,0,0,1,92.41,57.41v6.12A10.94,10.94,0,0,1,81.47,74.47H44.53A10.94,10.94,0,0,1,33.59,63.53V57.41A29.41,29.41,0,0,1,63,28Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 85.98,
    cy: 74.31,
    r: 6.43
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64,124a59.62,59.62,0,0,0,33-9.92l-2.66-7.44A10,10,0,0,0,85,100H41.05a10,10,0,0,0-9.42,6.64L29.36,113A59.74,59.74,0,0,0,64,124Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.92,100H43.08a20,20,0,0,0,39.84,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72,101.25a9,9,0,0,1-18,0c0-5,4-3,9-3S72,96.28,72,101.25Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 63,
    x2: 63,
    y1: 87.75,
    y2: 101.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 40.02,
    cy: 74.31,
    r: 6.43
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63,98.84a23,23,0,0,1-23-23V60.76a23,23,0,0,1,46,0V75.87A23,23,0,0,1,63,98.84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44.82,51A19.9,19.9,0,0,1,62.4,38.54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.82,58.82A25.82,25.82,0,0,0,62.27,33c-14.06.39-25.09,12.28-25.09,26.35v4a4.83,4.83,0,0,0,1.48,3.51,5.93,5.93,0,0,0,1.36,1V64a4,4,0,0,1,4-4h5.38a1,1,0,0,0,.9-.55L52,56l1.72,3.45a1,1,0,0,0,.9.55H82a4,4,0,0,1,4,4v3.89a5.93,5.93,0,0,0,1.36-1,4.83,4.83,0,0,0,1.48-3.51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M70.67,75.28a3,3,0,0,1,6,0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 62.5,
    x2: 62.5,
    y1: 77.5,
    y2: 81.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 72,
    x2: 79,
    y1: 68,
    y2: 68
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55,75.28a3,3,0,0,0-6,0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 54,
    x2: 47,
    y1: 68,
    y2: 68
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.55,86a1,1,0,0,1,.94,1.07,8.56,8.56,0,0,1-17,0A1,1,0,0,1,55.45,86Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58,92.91a8.52,8.52,0,0,0,10.08,0C67,91.16,65.17,91,63,91S59,91.16,58,92.91Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68,88H58a1.84,1.84,0,0,1-1.73-2H69.77A1.84,1.84,0,0,1,68,88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.39690680405e7c9746148b668243500f.svg";
export { ForwardRef as ReactComponent };